import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { quasarOptions } from './quasar';
import Quasar from 'quasar/src/vue-plugin.js';;
import L from 'leaflet';
import 'setimmediate'; // needed for logdna
// @ts-expect-error - leaflet image imports handled by webpack
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
// @ts-expect-error - leaflet image import
import iconUrl from 'leaflet/dist/images/marker-icon.png';
// @ts-expect-error - leaflet image import
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

// FIX for leaflet/webpack marker bug
// see https://github.com/PaulLeCam/react-leaflet/issues/255
delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

// Catch known Leaflet bug: layers removed during a zoom animation still receive
// the zoomanim event, causing "_latLngToNewLayerPoint" null reference. Harmless.
window.addEventListener('error', (e) => {
  if (e.error?.message?.includes('_latLngToNewLayerPoint')) {
    e.preventDefault();
  }
});

const app = createApp(App);
app.use(store);
app.use(router);
app.use(Quasar, quasarOptions);

app.mount('#app');
